import { State } from '../types';
const isApproachingExpiry = (currentExpiry, tokenExpirationMarginSeconds) => {
    const now = Math.floor(Date.now() / 1000);
    return currentExpiry - now <= tokenExpirationMarginSeconds;
};
export const hasExpired = (expiryTime) => {
    if (!expiryTime)
        return false;
    const now = Math.floor(Date.now() / 1000);
    return now >= expiryTime;
};
export const isTokenRefreshRequired = ({ gatewayToken, tokenExpirationMarginSeconds, }) => {
    const { expiryTime, state } = gatewayToken || {};
    const isActive = state === State.ACTIVE;
    if (!expiryTime || !isActive)
        return false;
    return hasExpired(expiryTime) || isApproachingExpiry(expiryTime, tokenExpirationMarginSeconds);
};
export const getTokenRefreshIntervalMilliseconds = (expiryTime, tokenExpirationMarginSeconds) => {
    const now = Math.floor(Date.now() / 1000);
    const interval = expiryTime - now - tokenExpirationMarginSeconds;
    return interval > 0 ? interval * 1000 : 0;
};
export const isTokenActive = (token) => {
    if (!token)
        return false;
    if (token.state === State.ACTIVE || !token.expiryTime) {
        return true;
    }
    // token found but not active
    return false;
};
